var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.292,
    height: 46.297,
    viewBox: "0 0 46.292 46.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69793",
    "data-name": "Group 69793",
    transform: "translate(-332.708 -410)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69792",
    "data-name": "Group 69792",
    transform: "translate(6.708 6.709)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1029",
    "data-name": "Ellipse 1029",
    cx: 23.146,
    cy: 23.146,
    r: 23.146,
    transform: "translate(326 403.291)",
    fill: "#babac4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M0,29.976C4.187,26.6,12.136,24.91,16.785,24.91c4.777,0,13.039,1.789,17.123,5.347a24.333,24.333,0,0,1-16.673,7.288c-.255.009-.511.013-.763.013A21.887,21.887,0,0,1,0,29.976ZM7.009,9.964A9.869,9.869,0,0,1,16.785,0a9.869,9.869,0,0,1,9.777,9.964,9.869,9.869,0,0,1-9.777,9.964A9.869,9.869,0,0,1,7.009,9.964Z",
    transform: "translate(332.122 412.028)",
    fill: "#9191a0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionAvatar);
export default __webpack_public_path__ + "static/media/permission_avatar.d13a00e333561f3024da7a30ce6faa5d.svg";
export { ForwardRef as ReactComponent };